import React from 'react';
import GlobalStyles from './src/styles/GlobalStyles';
import 'rsuite/dist/rsuite.min.css';

export const wrapPageElement = ({ element }) => (
	<>
		<GlobalStyles />
		{element}
	</>
);
